import { UserDetails } from "../types";
class LoginService {
    private accessToken: string | null;
    private pwStrict: boolean | null = true;
    private activeUser: UserDetails = null;

    constructor() {
        try {
            this.accessToken = localStorage.getItem('JWT');
            this.activeUser = JSON.parse(localStorage.getItem('User'));
        }
        catch {
            this.accessToken = null;
            this.activeUser = null;
        }
    }

    getAccessToken = () => {
        return this.accessToken;
    }

    getActiveUser = () => {
        return this.activeUser;
    }

    logIn = async (email, password) => { 
        const url = 'account/login';
        const bodyData = JSON.stringify({
            email: email,
            password: password
        })

        const response = await fetch(url, { method: 'POST', headers: {'Content-Type': 'application/json'}, body: bodyData });
        if (response.ok) {
            const json = await response.json();

            this.accessToken = json.token;
            this.activeUser = json.user;
            localStorage.setItem('JWT', json.token);
            localStorage.setItem('User', JSON.stringify(json.user));
            return json;
        }

        //Triggered user lock out
        if (response.status === 302) {
            const json = await response.json();
            return json;
        }
        return await response.text();
    }

    logInWithToken = async (token: string, user: UserDetails) => {
        this.accessToken = token;
        this.activeUser = user;
        localStorage.setItem('JWT', token);
        localStorage.setItem('User', JSON.stringify(user));
    }

    register = async (email, password) => {
        const url = 'account/register';
        const bodyData = JSON.stringify({
            email: email,
            password: password
        })

        const response = await fetch(url, { method: 'POST', headers: {'Content-Type': 'application/json'}, body: bodyData });
        const json = await response.json();
        if (response.ok) {
            if (json.redirectUrl) {
                window.location.href = json.redirectUrl;
                return json;
            }

            this.accessToken = json.token;
            this.activeUser = json.user;
            localStorage.setItem('JWT', json.token);
            localStorage.setItem('User', JSON.stringify(json.user));
            return json;
        } else {
            console.log(json?.error);
        }
        return await response.text();
    }

    logOut = () => {
        this.accessToken = "";
        this.activeUser = null;
        localStorage.removeItem('JWT');
        localStorage.removeItem('User');
    }

    isAuthenticated = async () => {
        const response = await fetch("account/check-login", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.accessToken}`
            }
        }); 
        if (response.ok) {
            const json = await response.json();
            return json.success;
        }
    }

    isPwStrict = async (): Promise<boolean> => {
        if (this.pwStrict != null) return this.pwStrict;

        const url = 'account/pw-strict';
        const response = await fetch(url, { method: 'GET'});
        if (response.ok) {
            const json = await response.json();

            this.isPwStrict = json.pwStrict;
            return this.pwStrict;
        }

        return true;
    }

    demoLogin = async (password) => {
        const url = `account/demo-login?password=${password}`;

        const response = await fetch(url, { method: 'GET'});
        const json = await response.json();

        if (response.ok) 
            return json.secret;

        return null;
    }
}

export default new LoginService();
